jQuery(document).ready(function($) {

  // description toggles
  $('.description h2, .description p.close').on('click', function() {
    $('.dot').first().trigger('click')
    $('.product').toggleClass('description--is-showing')
    if ($('.product').hasClass('description--is-showing')) {
      $('.product').removeClass('showing-full-first').removeClass('showing-full-second')
    }
  })

  $('.flip-card-container').on('click', function() {
    var $pane = $(this).closest('.pane')
    $pane.toggleClass('caption--is-showing')
    if ($pane.hasClass('caption--is-showing')) {
      var scrollTop = $pane.offset().top + $pane.height() / 2
      $('html, body').stop().animate({scrollTop: scrollTop }, 500);
    }
  })

  $('.controls .flip').on('click', function() {
    var $pane = $(this).closest('.pane')
    $pane.find('.flip-card').toggleClass('flipped')
    $pane.find('.caption').removeClass('caption--is-showing')
  })

  $('.dots .dot').on('click', function() {
    var $dot = $(this)
    var dotIndex = $dot.index()
    var $setsDots = $dot.closest('.sets-dots')
    var $sets = $setsDots.find('.sets')
    var $dots = $setsDots.find('.dots')
    $sets.find('.set').removeClass('set--is-showing').eq(dotIndex).addClass('set--is-showing')
    $dots.find('.dot').removeClass('dot--is-active').eq(dotIndex).addClass('dot--is-active')
  })

});
